import { auth, BASE_CLOUD_FUNCTION_URL } from 'external/firebase/index';

import { formatErrorMessage } from './utils';

export const searchStripeCustomer = async (email: string) => {
    try {
        const response = await fetch(`${BASE_CLOUD_FUNCTION_URL}/stripe/customers/search?email=${email}`);
        return await response.json();
    } catch (error) {
        return formatErrorMessage(error);
    }
};

export const fetchStripeCustomers = async (from: number, to: number) => {
    try {
        if (!auth.currentUser) {
            throw new Error('auth/user-not-found');
        }
        const response = await fetch(`${BASE_CLOUD_FUNCTION_URL}/stripe/export/customers?from=${from}&to=${to}`, {
            headers: {
                // @ts-ignore
                Authorization: `Bearer ${auth.currentUser.accessToken}`,
            },
        });
        return await response.json();
    } catch (error) {
        return formatErrorMessage(error);
    }
};

export const fetchStripeInvoices = async (from: number, to: number) => {
    try {
        if (!auth.currentUser) {
            throw new Error('auth/user-not-found');
        }
        const response = await fetch(`${BASE_CLOUD_FUNCTION_URL}/stripe/export/invoices?from=${from}&to=${to}`, {
            headers: {
                // @ts-ignore
                Authorization: `Bearer ${auth.currentUser.accessToken}`,
            },
        });
        return await response.json();
    } catch (error) {
        return formatErrorMessage(error);
    }
};

export const fetchStripeCharges = async (from: number, to: number) => {
    try {
        if (!auth.currentUser) {
            throw new Error('auth/user-not-found');
        }
        const response = await fetch(`${BASE_CLOUD_FUNCTION_URL}/stripe/export/charges?from=${from}&to=${to}`, {
            headers: {
                // @ts-ignore
                Authorization: `Bearer ${auth.currentUser.accessToken}`,
            },
        });
        return await response.json();
    } catch (error) {
        return formatErrorMessage(error);
    }
};
